import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="bg-white rounded-xl p-8 border border-gray-200 max-w-md w-full text-center shadow-sm">
        <XCircle className="h-16 w-16 text-gray-400 mx-auto mb-6" />
        <h2 className="text-xl font-bold text-gray-900 mb-2">{"Paiement annulé"}</h2>
        <p className="text-sm text-gray-500 mb-6">
          {"Vous avez annulé le processus de paiement. Aucun montant n\u2019a été prélevé."}
        </p>
        <Link
          to="/payment/product"
          className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-semibold px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors w-full"
        >
          <ArrowLeft className="h-4 w-4" />
          {"Retour à la formation"}
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
